(
    function (skyward, $, undefined)
    {
        var defaultSettings =
        {
            color: "",
            preferredFormat: "hex",
            theme: "sp-skyward ui-control-container",
            palette: [
                ["rgb(0, 0, 0)", "rgb(67, 67, 67)", "rgb(102, 102, 102)", "rgb(153, 153, 153)", "rgb(183, 183, 183)",
                    "rgb(204, 204, 204)", "rgb(217, 217, 217)", "rgb(239, 239, 239)", "rgb(243, 243, 243)", "rgb(255, 255, 255)"],
                ["rgb(152, 0, 0)", "rgb(255, 0, 0)", "rgb(255, 153, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)",
                    "rgb(0, 255, 255)", "rgb(74, 134, 232)", "rgb(0, 0, 255)", "rgb(153, 0, 255)", "rgb(255, 0, 255)"],
                ["rgb(230, 184, 175)", "rgb(244, 204, 204)", "rgb(252, 229, 205)", "rgb(255, 242, 204)", "rgb(217, 234, 211)",
                    "rgb(208, 224, 227)", "rgb(201, 218, 248)", "rgb(207, 226, 243)", "rgb(217, 210, 233)", "rgb(234, 209, 220)"],
                ["rgb(221, 126, 107)", "rgb(234, 153, 153)", "rgb(249, 203, 156)", "rgb(255, 229, 153)", "rgb(182, 215, 168)",
                    "rgb(162, 196, 201)", "rgb(164, 194, 244)", "rgb(159, 197, 232)", "rgb(180, 167, 214)", "rgb(213, 166, 189)"],
                ["rgb(204, 65, 37)", "rgb(224, 102, 102)", "rgb(246, 178, 107)", "rgb(255, 217, 102)", "rgb(147, 196, 125)",
                    "rgb(118, 165, 175)", "rgb(109, 158, 235)", "rgb(111, 168, 220)", "rgb(142, 124, 195)", "rgb(194, 123, 160)"],
                ["rgb(166, 28, 0)", "rgb(204, 0, 0)", "rgb(230, 145, 56)", "rgb(241, 194, 50)", "rgb(106, 168, 79)",
                    "rgb(69, 129, 142)", "rgb(60, 120, 216)", "rgb(61, 133, 198)", "rgb(103, 78, 167)", "rgb(166, 77, 121)"],
                ["rgb(133, 32, 12)", "rgb(153, 0, 0)", "rgb(180, 95, 6)", "rgb(191, 144, 0)", "rgb(56, 118, 29)",
                    "rgb(19, 79, 92)", "rgb(17, 85, 204)", "rgb(11, 83, 148)", "rgb(53, 28, 117)", "rgb(116, 27, 71)"],
                ["rgb(91, 15, 0)", "rgb(102, 0, 0)", "rgb(120, 63, 4)", "rgb(127, 96, 0)", "rgb(39, 78, 19)",
                    "rgb(12, 52, 61)", "rgb(28, 69, 135)", "rgb(7, 55, 99)", "rgb(32, 18, 77)", "rgb(76, 17, 48)"]
            ]
        };

        var defaultInputAndPaletteSettings = $.extend({}, defaultSettings,
        {
            showPalette: true,
            showInput: true,
            palette:
            [
                ["#FFFFCC", "#FFFF99", "#CCCC99", "#CCFFCC", "#99FF99"],
                ["#99CC99", "#CCFFFF", "#99FFFF", "#99CCCC", "#CCCCFF"],
                ["#9999FF", "#9999CC", "#FFCCFF", "#FF99FF", "#CC99CC"],
                ["#FFCCCC", "#FF9999", "#CC9999", "#FFFFFF", "#CCCCCC"]
            ],
            chooseText: "Select"
        });

        var defaultPartialPaletteOnlySettings = $.extend({}, defaultSettings,
        {
            showPaletteOnly: true,
            hideAfterPaletteSelect: true,
            palette:
            [
                ["#CCFF00", "#FF9966", "#FF99CC", "#5575B4", "#66CCCC"],
                ["#CCCCFF", "#A30000", "#009999", "#5BCF57", "#FFCC33"]
            ],
            chooseText: "Select"
        });

        var defaultPaletteOnlySettings = $.extend({}, defaultSettings,
        {
            showPaletteOnly: true,
            hideAfterPaletteSelect: true,
            palette: [["#FFFFFF", "#000000"]]
        });

        var teacherInputPaletteSettings = $.extend({}, defaultSettings,
        {
            showPalette: true,
            showInput: true,
            palette:
                [
                    ["#aafaa8", "#f4fe8f", "#fc9e6e", "#faaaa8"],
                    ["#049c00", "#e8ff00", "#ff9a00", "#ff0000"]
                ],
            chooseText: "Select"
        });

        function init(selector)
        {
            $(selector).find("input.colorPicker").each(function ()
            {
                var colorPicker = $(this);
                var settings = getControlSettings(colorPicker);
                colorPicker.spectrum(settings);
                addAccessibility(colorPicker, settings);
            });
        }

        function addAccessibility(control, settings)
        {
            var picker = control.next(".sp-skyward");
            if (picker.length === 0)
            {
                return;
            }
            var tabindex = control.prop("disabled") ? -1 : 0;
            //add tabindex so the picker is keyboard accessible
            picker.attr("tabindex", tabindex);
            // make sure labels with `for` attributes still point to this control
            if (settings.id)
            {
                const label = $(`[for=${settings.id}]`);
                if (label.length > 0)
                {
                    picker.attr("aria-labelledby", label.addIds().attr("id"));
                }
                picker.attr("id", settings.id + "_picker");
            }
            picker.attr("role", "combobox");

            picker.on("enter", function (event)
            {
                picker.trigger("click");
            });

            var container = control.spectrum("container");

            container.on("enter", ".sp-thumb-el", function ()
            {
                var swatch = $(this);
                var hasDoneButton = container.find(".sp-choose:visible").length > 0;
                swatch.trigger("click");    
                
                // If there is a done button the dialog will be rebuilt and the tabindexes will be lost.
                //call .show to ensure the tabindexes are re-built
                if (hasDoneButton)
                {
                    settings.show();
                }
            });
        }

        function getControlSettings(control)
        {
            var defaultSettings;
            
            if (control.hasClass("textColorPicker"))
            {
                defaultSettings = defaultPaletteOnlySettings;
            }
            else if (control.hasClass("partialPaletteOnly"))
            {
                defaultSettings = defaultPartialPaletteOnlySettings
            }
            else if (control.hasClass("teacherInputPaletteSettings"))
            {
                defaultSettings = teacherInputPaletteSettings;
            }
            else
            {
                defaultSettings = defaultInputAndPaletteSettings;
            }
            
            var settings = $.extend({}, defaultSettings);
            var controlData = control.data();
            
            if (controlData.colorPalette)
            {
                var paletteArray = controlData.colorPalette.split(",");
                var partialArray = [];
                var fullArray = [];

                for (var i = 0; i < paletteArray.length; i++)
                {
                    if (i % 5 == 0)
                    {
                        partialArray = [];
                        fullArray.push(partialArray);
                    }

                    partialArray.push(paletteArray[i]);
                }

                settings.palette = fullArray;
            }

            if (control.is("[readonly]"))
            {
                settings.disabled = true;
            }

            setSettingsCallbacks(control, settings);
            settings.id = control.attr("id");

            return settings;
        }

        function setSettingsCallbacks(control, settings)
        {
            var modalLayer;
            var buttonsReplaced = false;
            
            settings.beforeShow = beforeShow;
            settings.show = show;
            settings.move = move;
            settings.hide = hide;

            function beforeShow(color)
            {
                var container = control.spectrum("container");

                if (!buttonsReplaced)
                {
                    // We replace native buttons with our own to override styles and ordering
                    replaceButtons(container);
                    buttonsReplaced = true;
                }

                var beforeClose = function (layer, reason)
                {
                    // cancel the change on escape
                    if (reason === "escape")
                    {
                        container.find(".sp-cancel").click();
                    }
                    layer.container.find(container).detach();
                };

                var options =
                {
                    closeOnClick: false,
                    initialFocusElement: ".sp-thumb-active"
                };

                // We place the picker in a modal layer to prevent interaction outside of it
                modalLayer = skyward.modalLayer.newModalLayer(container, beforeClose, options);
            }

            function show(color)
            {
                var container = control.spectrum("container");
                if (!settings.showPaletteOnly)
                {
                    // Clicking off of the color picker should not close
                    $(control[0].ownerDocument).off("click.spectrum");
                }

                initialColor = tinycolor(color);

                // We replace the checkmark over transparent swatches to be more visible
                replaceTransparentSwatchCheckmark(container);

                container.find(".sp-thumb-el").attr("tabindex", 0);
                skyward.dialogFocusManager.setFocus(modalLayer);
            }

            function move(color)
            {
                // We replace the checkmark over transparent swatches to be more visible
                replaceTransparentSwatchCheckmark(control.spectrum("container"));
            }

            function hide(color)
            {
                if (modalLayer && !modalLayer.closing)
                {
                    modalLayer.close();
                }
            }
        }

        function replaceButtons(container)
        {
            var buttonContainer = container.find(".sp-button-container");

            replaceButton(buttonContainer, ".sp-choose", "Save", "Save");
            replaceButton(buttonContainer, ".sp-cancel", "Cancel", "Cancel");
        }

        function replaceButton(buttonContainer, selector, icon, text)
        {
            var button = buttonContainer.find(selector);
            button.css("display", "none");
            buttonContainer.append(getReplacementButton(button, icon, text));
        }

        function getReplacementButton(button, icon, text)
        {
            var svg = skyward.svg.getSvg(icon).addClass("buttonSvg svgNoHover");
            var textSpan = $("<span>", { class: "sp-buttonText" }).html(text);

            // To override !important color picker styling
            textSpan.css("color", "black");

            var replacementButton = $("<a>", { href: "javascript:void(0)", class: button.attr("class") + " sp-skyward-button" }).html(svg).append(textSpan);
            replacementButton.on("click", function () { button.click(); });

            return replacementButton;
        }

        function replaceTransparentSwatchCheckmark(container)
        {
            var activeSwatch = container.find(".sp-thumb-active");
            if (!activeSwatch.length)
            {
                return;
            }

            var color = activeSwatch.data("color");
            if (!color)
            {
                return;
            }

            var isTransparent = tinycolor(color).getAlpha() === 0;
            if (!isTransparent)
            {
                return;
            }

            activeSwatch.removeClass("sp-thumb-dark");
            activeSwatch.addClass("sp-thumb-light");
        }

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);